import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    boxSizing: 'border-box',
    alignItems: 'stretch',
    flexFlow: 'column nowrap',
    backgroundColor: theme.palette.background.default,
    flex: '0 0 auto',
    justifyContent: 'space-between',
    padding: theme.spacing(1.875),
    borderRadius: theme.spacing(1.25),
    height: '100%',
    cursor: 'default',

    [theme.breakpoints.up('lg')]: {
      minHeight: theme.spacing(9),
    },

    [theme.breakpoints.down('lg')]: {
      minHeight: theme.spacing(11.75),
    },
  },
  header: {
    flex: '0 0 auto',
    fontSize: theme.spacing(2.75),
    letterSpacing: '0.05em',
    lineHeight: 1,
    fontWeight: 400,
    fontFamily: '"Bebas Neue"',
    textTransform: 'uppercase',
  },

  description: {
    flex: '0 0 auto',
    fontSize: theme.spacing(1.75),
    letterSpacing: '0.05em',
    lineHeight: 1.3,
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}));
